module.exports = __webpack_public_path__ + "static/feature6-b762d0cfbf2b0cefba07c76414ed1db9.png";